import { createSlice } from "@reduxjs/toolkit";

export const empSlice = createSlice({
  name: "emp",
  initialState: {
    employee: null,
    company: null,
    started: 0,
    stopped: 0,
    dashboardCheck: 0,
    EmpIpAddress: 0,
    sessionId: 0,
    onBreak: 0,
  },
  reducers: {
    login: (state, action) => {
      state.employee = action.payload;
    },
    company: (state, action) => {
      state.company = action.payload;
    },
    logout: (state) => {
      state.employee = null;
      state.company = null;
      state.started = null;
      state.stopped = null;
      state.dashboardCheck = null;
      state.EmpIpAddress = null;
      state.sessionId = null;
      state.onBreak = null;
    },
    setStarted: (state, action) => {
      state.started = action.payload;
    },
    setStopped: (state, action) => {
      state.stopped = action.payload;
    },
    setDashboardCheck: (state, action) => {
      state.dashboardCheck = action.payload;
    },
    removeDashboardCheck: (state) => {
      state.dashboardCheck = null;
    },
    setEmpIpAddress: (state, action) => {
      state.EmpIpAddress = action.payload;
    },
    removeEmpIpAddress: (state) => {
      state.EmpIpAddress = null;
    },
    setSessionIdData: (state, action) => {
      state.sessionId = action.payload;
    },
    setOnBreak: (state, action) => {
      state.onBreak = action.payload;
    },
  },
});

export const {
  login,
  logout,
  company,
  setStarted,
  setStopped,
  setDashboardCheck,
  removeDashboardCheck,
  setEmpIpAddress,
  removeEmpIpAddress,
  setSessionIdData,
  setOnBreak,
} = empSlice.actions;

export const selectEmployee = (state) => state.emp.employee;
export const selectCompany = (state) => state.emp.company;
export const selectStarted = (state) => state.emp.started;
export const selectStopped = (state) => state.emp.stopped;
export const selectSessionId = (state) => state.emp.sessionId;
export const selectDashboardCheck = (state) => state.dashboardCheck;
export const selectOnBreak = (state) => state.emp.onBreak;

export default empSlice.reducer;
